import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { Image, Popup } from 'semantic-ui-react';

import defaultImage from '../assets/book_cover_icon.svg'; // Replace with your default image path
import defaultBookImage from '../assets/narrator_1-1-480x490.png'; // Replace with your default image path
import '../index.css';


export const FileDropzone = ({ setFieldValue, fieldName, onDropCallback, hintText, altText, imgItem }) => {
  const onDrop = useCallback(acceptedFiles => {
    const file = acceptedFiles[0];
    setFieldValue(fieldName, file);
    onDropCallback(URL.createObjectURL(file));
  }, [setFieldValue, fieldName, onDropCallback]);

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <>
      <div className="dndContainer">
        <div {...getRootProps()}>
          <input {...getInputProps()} />
          <p className="dndHint">{hintText}</p>
        </div>
      </div>
      <div className='dndImgContainer'>
        {imgItem && <img className="ble-hero-img" src={imgItem} alt={altText} />}
      </div>
    </>
  );
};

export const FileDropzoneSideImg = ({ setFieldValue, fieldName, onDropCallback, hintText, altText, imgItem }) => {


  const onDrop = useCallback(acceptedFiles => {
    const file = acceptedFiles[0];
    setFieldValue(fieldName, file);
    onDropCallback(URL.createObjectURL(file));
  }, [setFieldValue, fieldName, onDropCallback]);

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <>
      <div className="dndParentContainer">
        <div className="dndContainerImg">
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            <p className="dndHint">{hintText}</p>
          </div>
        </div>
        <div className='dndImgContainerImg'>
          {imgItem &&
            <img className="dnd-ble-hero-img" src={imgItem} alt={altText} />}
        </div>
      </div>
    </>
  );
};

// export const FileDropzoneOverImg = ({ setFieldValue, fieldName, onDropCallback, hintText = "Click or drag a file here", altText = "File preview", imgItem }) => {
//   const onDrop = useCallback(acceptedFiles => {
//     const file = acceptedFiles[0];
//     setFieldValue(fieldName, file);
//     onDropCallback(URL.createObjectURL(file));
//   }, [setFieldValue, fieldName, onDropCallback]);

//   const { getRootProps, getInputProps } = useDropzone({ onDrop });

//   return (
//     <div className="">
//       <div className="dndBookCoverContainerImg" {...getRootProps()}>
//         <input {...getInputProps()} />
//         <Image
//           src={imgItem || defaultImage}
//           size='medium'
//           alt={altText}
//           className="dnd-ble-hero-img"
//           style={{ cursor: 'pointer' }}
//         />
//         {/* <p className="dndHint">{hintText}</p> */}
//       </div>
//     </div>
//   );
// };

export const FileDropzoneOverImg = ({ onDropCallback, hintText = "Click or drag a file here", altText = "Image preview", imgItem, overlayText = "" }) => {
  const onDrop = useCallback(acceptedFiles => {
    const file = acceptedFiles[0];
    onDropCallback(file, URL.createObjectURL(file));
  }, [onDropCallback]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png', '.gif', '.webp']
    }
  });

  return (
    <div {...getRootProps()} style={{ display: 'inline-block', position: 'relative' }}>
      <input {...getInputProps()} />
      <Popup
        content={hintText}
        trigger={
          <Image
            src={imgItem || defaultImage}
            // size='medium'
            alt={altText}
            className="dnd-ble-over-img"
          />
        }
        position='top center'
        size='small'
      />
      {imgItem && overlayText ? <div className="overlay-text">{overlayText}</div> : null}
    </div>
  );
};

export const FileDropzonePdf = ({ onDropCallback, hintText = "Click or drag a file here", altText = "Pdf preview", imgItem, showOverLay = true }) => {
  const onDrop = useCallback(acceptedFiles => {
    const file = acceptedFiles[0];
    onDropCallback(file, URL.createObjectURL(file));
  }, [onDropCallback]);

  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  return (
    <div {...getRootProps()} style={{ display: 'inline-block' }}>
      <input {...getInputProps()} />
      <Popup
        content={hintText}
        trigger={
          <Image
            // src={'./narrator_1-1-480x490.png'}
            src={imgItem || defaultBookImage}
            size='medium'
            alt={altText}
            className="dnd-ble-over-img"
            style={{ cursor: 'pointer', height: "80px", width: "auto" }}
          />
        }
        position='top center'
        size='small'
      />
      {imgItem && showOverLay ? <div className="overlay-text">Story pdf file</div> : null}

    </div>
  );
};
